import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
// import { MatDialogRef } from '@angular/material';
import { ReportingService } from './reporting.service';

import { LoginService } from '../login/login.service';
import { YearService } from '../../shared-components/year/year.service';
import { LoginSettings } from '../login/LoginSetting.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserService } from '../../shared-components/user/user.service';

import { ClassroomSummaryService } from '../../classroom360/classroom-summary/classroom-summary.service';
import { StudentService } from '../../shared-components/student/student.service';

import { MyReportsComponent } from './my-reports/my-reports.component';
import { SecurityService } from '../../shared-components/security/security.service';

@AutoUnsubscribe()
@Component({
    selector: 'report',
    templateUrl: './reporting.component.html'
})

export class ReportingComponent implements OnInit, OnDestroy {
    @ViewChild(MyReportsComponent) myReportsComponent: MyReportsComponent;
    // @ViewChild(AllReportsComponent) allReportsComponent: AllReportsComponent;

    loginSettings: LoginSettings;
    // expandAllFolders: boolean;

    // for expanding/collapsing MyReports folders
    @Output() expandAllFolders: EventEmitter<boolean> = new EventEmitter();
    @Output() hideFoldersButton: EventEmitter<boolean> = new EventEmitter(); // for footer

    @Input() refreshedReportFolders: boolean; // from footer after adding first folder?

    // get foldersWereFreshed

    private _isMyReports: boolean;
    private _isAllReports: boolean;
    private _userCanAutoRunReports: boolean;

    // @Input() showAllReports: boolean;
    // @Input() showMyReports: boolean;

    get isMyReports(): boolean {
        // return _isMyReports;
        return this.reportService.isMyReports;
    }

    set isMyReports(value: boolean) {
        this.reportService.isMyReports = value;
        // _isMyReports = value;
    }

    get isAllReports(): boolean {
        return this.reportService.isAllReports;
    }

    set isAllReports(value: boolean) {
        this.reportService.isAllReports = value;
    }

    get userCanAutoRunReports(): boolean {
        return this._userCanAutoRunReports;
    }

    set userCanAutoRunReports(value: boolean) {
        this._userCanAutoRunReports = value;
        this.reportService.userCanAutoRunReports = value;
    }

    private _showNoFoldersMessage: boolean;

    get showNoFoldersMessage(): boolean {
        // return this._showNoFoldersMessage;
        return this.reportService.showNoFoldersMessage;
    }

    set showNoFoldersMessage(value: boolean) {
        this._showNoFoldersMessage = value;
        this.reportService.showNoFoldersMessage = value;
    }

    // get oneSisModules(): ReportModule[] {
    //     return this.reportService.oneSisModules;
    // }

    // set oneSisModules(value: ReportModule[]) {
    //     this.reportService.oneSisModules = value;
    // }

    showAllReportsComponent: boolean;

    // userPermissions: UserPermission[];

    // userRoles: UserRole[] = [];

    hasClassroom360Role: boolean;
    hasStudent360Role: boolean;
    hasCounselor360Role: boolean;

    allowArchiveReportPDF: boolean;
    utilizeTranscriptTracking: boolean;



    constructor(
        private reportService: ReportingService,
        private loginService: LoginService,
        private userService: UserService,
        private yearService: YearService,
        // private classroomSummaryService: ClassroomSummaryService,
        private classroomSummaryService: ClassroomSummaryService,
        private studentService: StudentService,
        private securityService: SecurityService
    ) {
        this.loginSettings = loginService.LoginSettings;

    } // end constructor


    ngOnInit() {
        this.reportService.isMyReports = true; // defaults to my reports
        this.reportService.isAllReports = false;

        this.isMyReports = this.reportService.isMyReports;
        this.isAllReports = this.reportService.isAllReports;

        this.showAllReportsComponent = false;
        this.getUserPermissions();
        this.reportService.maxReportSnapshotAllowed = this.loginService.LoginSettings.MaxReportSnapshotAllowed;
        this.reportService.defaultAcademicYear = this.yearService.defaultYear.AYIdentifier;
        // this.getUserRoles();
        // this.getReportModulesByRole();



        // if (!this.isForSchedule) {
        this.reportService.selectedCourse = this.classroomSummaryService.selectedCourse;
        this.reportService.selectedStudent = this.studentService.selectedStudent;
        // }

        // if (this.reportService.inDebugMode) {
        //     console.log('this.reportService.useReportDefinitions: ' + this.reportService.useReportDefinitions);
        //     console.log(this.reportService.selectedCourse);
        //     console.log(this.reportService.selectedStudent );
        // }

        this.reportService.getReportingConfigurationSettings(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.AYIdentifier)
        .subscribe(settings => {
          this.reportService.reportingConfigurationSettings = settings;
        });
    }

    ngOnDestroy() {

        // if (this.reportService.inDebugMode) {
        //     console.log('ngOnDestroy()');
        // }

        // do any necessary cleanup here for instance properties in the reporting service
        this.reportService.autoRunSnapshot = null;
        this.reportService.SelectedReport = null;
        this.reportService.ReportFolders = null;
        this.reportService.ReportFolderToEdit = null;
        // this.reportService.reportMode = null;
    }

    getUserPermissions() {

        this.userCanAutoRunReports = this.loginService.LoginSettings.AllowAutoRunReport;

        this.utilizeTranscriptTracking = this.loginService.LoginSettings.UtilizeTranscriptTracking;

        this.allowArchiveReportPDF = this.loginService.LoginSettings.AllowArchiveReportPDF;

        // if (this.reportService.inDebugMode) {
        //     console.log('this.userCanAutoRunReports: ' + this.userCanAutoRunReports);
        //     console.log('utilizeTranscripttracking: ' + this.utilizeTranscriptTracking);
        //     console.log('allowArchiveReportPDFs: ' + this.allowArchiveReportPDF);
        // }


        // userHasPrivilegeAddEditDistrictReportDefinitions

        // POST: obtains the permissions from the server
        const permissions = this.securityService.userPermissions;

        // Add/Edit & Autorun Report Configuration & AddEditAutorunConfiguration
        // if (permissions.find(permission => permission.PrivilegeId == 2325 /* Report Definition Options */)) {
        //     this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions = true;
        // }
        if (permissions.find(permission => permission.PermissionName == 'Report Definition Options')) {
            this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions = true;
        }
        else {
            this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions = false;
        }

        // report archive permissions
        if (permissions.find(permission => permission.PermissionName == 'View Archive Processes From All Users')) {
            this.reportService.viewArchiveProcessesFromAllUsers = true;
        }
        else {
            this.reportService.viewArchiveProcessesFromAllUsers = false;
        }

        if (permissions.find(permission => permission.PermissionName == 'Allow Cancel Archive Processes')) {
            this.reportService.allowCancelArchiveProcesses = true;
        }
        else {
            this.reportService.allowCancelArchiveProcesses = false;
        }

        if (permissions.find(permission => permission.PermissionName == 'Allow Delete Archived Reports')) {
            this.reportService.allowDeleteArchivedReports = true;
        }
        else {
            this.reportService.allowDeleteArchivedReports = false;
        }

        // this.reportService.getReportingConfigurationSettings(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.AYIdentifier)
        // .subscribe(settings => {
        //   this.reportService.reportingConfigurationSettings = settings;
        // });
        // if (this.reportService.inDebugMode) {
        //     console.log('viewArchiveProcessesFromAllUsers: ' + this.reportService.viewArchiveProcessesFromAllUsers);
        //     console.log('allowCancelArchiveProcesses: ' + this.reportService.allowCancelArchiveProcesses);
        //     console.log('allowDeleteArchivedReports: ' + this.reportService.allowDeleteArchivedReports);
        // }

    }

    // getReportModulesByRole() {
    //     const selectedSchoolDomain = this.yearService.defaultYear.SchoolID;
    //     this.reportService.getReportModulesByRole(selectedSchoolDomain).subscribe(reportModules => {
    //         if (this.reportService.inDebugMode) {
    //             console.log(reportModules);
    //         }

    //         // clear the array
    //         this.oneSisModules.length = 0;

    //         if (reportModules.length > 1) {
    //             // then need to add ALL
    //             const allReportsReportModule = new ReportModule();
    //             allReportsReportModule.ID = 0;
    //             allReportsReportModule.Description = 'All';
    //             allReportsReportModule.IsSelected = true;
    //             this.oneSisModules.push(allReportsReportModule);
    //         }

    //         for (let i; i < reportModules.length; i++) {
    //             this.oneSisModules.push(reportModules[i]);
    //         }

    //         if (reportModules.length > 0) {
    //             reportModules[0].IsSelected = true;
    //         }


    //     });
    // }

    // getUserRoles() {
    //     const selectedSchoolDomain = this.yearService.defaultYear.SchoolID;
    //     this.userService.getUserRoles(
    //         this.yearService.defaultYear.Id
    //     ).subscribe(roles => {
    //         // Classroom 360
    //         if (roles.find(role => role.School_Domain == selectedSchoolDomain && (role.RoleName == 'My Classes' || role.RoleName == 'Gradebook'))) {
    //         }
    //         else {
    //             this.hasClassroom360Role = false;
    //         }

    //         // Student 360
    //         if (roles.find(role => role.School_Domain == selectedSchoolDomain && (role.RoleName == 'My Students'))) {
    //             this.hasStudent360Role = true;
    //         }
    //         else {
    //             this.hasStudent360Role = false;
    //         }

    //         // Counselor 360
    //         if (roles.find(role => role.School_Domain == selectedSchoolDomain && (role.RoleName == 'Academic Management' || role.RoleName == 'Counselor Functions' || role.RoleName == 'Scheduling Utility Administrator'))) {
    //             this.hasCounselor360Role = true;
    //         }
    //         else {
    //             this.hasCounselor360Role = false;
    //         }




    //         // if (this.userPermissions.find(permission

    //         if (this.reportService.inDebugMode) {
    //             console.log('hasClassroom360Role:' + this.hasClassroom360Role);
    //             console.log('hasStudent360Role:' + this.hasStudent360Role);
    //             console.log('hasCounselor360Role:' + this.hasCounselor360Role);
    //             console.log('selectedSchoolDomain:' + selectedSchoolDomain);
    //             console.log(roles);


    //         }

    //         // // Add/Edit & Autorun Report Configuration & AddEditAutorunConfiguration
    //         // if (this.userPermissions.find(permission => permission.PermissionName == 'Add/Edit & Autorun Report Configuration' || permission.PermissionName == 'AddEditAutorunConfiguration')) {
    //         //     this.userCanAutoRunReports = true;
    //         // } else {
    //         //     this.userCanAutoRunReports = false;
    //         //     this.isAllReports = true;
    //         //     this.isMyReports = false;
    //         // }
    //         // this.hideFoldersButton.emit(!this.userCanAutoRunReports);

    //     });
    // }

    // ngOnChanges() { }

    expandAllFoldersClick(expand: boolean) {
        // this.expandAllFolders = expandAll;

        // console.log('expandAllFoldersClick: ' + expand);

        this.myReportsComponent.expandAllFoldersClick(expand);


        if (expand != null) {
            this.expandAllFolders.emit(expand);
        }
    }

    reportFoldersRefreshed(wereRefreshed: boolean) {
        // this.expandAllFolders = expandAll;

        // console.log('reportFoldersRefreshed()');

        // this.myReportsComponent.ReportFolders = this.reportService.ReportFolders;
        if (wereRefreshed == true) {
            this.myReportsComponent.getMyReportFolders();
        }

    }




} // end export class ReportingComponent


